import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "table-responsive table-responsive-sm table-responsive-md",
    id: "card"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "table table-bordered grid" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "text-capitalize" };
const _hoisted_6 = ["data-label"];
const _hoisted_7 = { key: 0 };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { class: "controls" };
const _hoisted_11 = { class: "btn-group" };
const _hoisted_12 = ["title", "onClick"];
const _hoisted_13 = ["title", "onClick"];
const _hoisted_14 = ["title", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.showPagination && !$props.pageInfo && !$props.isLoading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('JTADM_GRID_ROWS') + ': ' + $setup.sortedFilteredData.length), 1))
            : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (value, key) => {
                        return (_openBlock(), _createElementBlock("th", {
                            key: key,
                            scope: "col",
                            class: _normalizeClass({ active: $setup.sortKey == key }),
                            onClick: ($event) => ($setup.sortBy(key))
                        }, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(value), 1),
                            _createElementVNode("span", {
                                class: _normalizeClass(["arrow", $setup.sortOrders[$setup.sortKey] > 0 ? 'asc ' : 'dsc'])
                            }, null, 2)
                        ], 10, _hoisted_4));
                    }), 128)),
                    _withDirectives((_openBlock(), _createElementBlock("th", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('JTADM_GRID_CONTROLS')), 1)
                    ])), [
                        [_directive_acl, $props.access, "grid_view_control"]
                    ])
                ])
            ]),
            _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedFilteredData, (entry, k) => {
                    return (_openBlock(), _createElementBlock("tr", {
                        key: k,
                        scope: "row"
                    }, [
                        ($props.paginatedResults || (k >= $setup.start && k < $setup.end))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (key, value) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                        key: key,
                                        "data-label": key
                                    }, [
                                        ($setup.isHTML(entry[value]) && $props.allowHtml)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createElementVNode("span", {
                                                    innerHTML: entry[value]
                                                }, null, 8, _hoisted_8)
                                            ]))
                                            : (key != null)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(entry[value]), 1))
                                                : _createCommentVNode("", true)
                                    ], 8, _hoisted_6));
                                }), 128)),
                                _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        ($setup.props.onView)
                                            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-small btn-info text-white",
                                                title: _ctx.$t('JTADM_GRID_SHOW'),
                                                onClick: ($event) => (_ctx.$emit('view', entry))
                                            }, [...(_cache[1] || (_cache[1] = [
                                                    _createElementVNode("i", { class: "dripicons-preview" }, null, -1)
                                                ]))], 8, _hoisted_12)), [
                                                [_directive_acl, $props.access, "grid_view_control"]
                                            ])
                                            : _createCommentVNode("", true),
                                        ($setup.props.onEdit)
                                            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "btn btn-small btn-warning",
                                                "data-cy": "edit",
                                                title: _ctx.$t('JTADM_GRID_EDIT'),
                                                onClick: ($event) => (_ctx.$emit('edit', entry))
                                            }, [...(_cache[2] || (_cache[2] = [
                                                    _createElementVNode("i", { class: "dripicons-pencil" }, null, -1)
                                                ]))], 8, _hoisted_13)), [
                                                [_directive_acl, $props.access, "grid_edit_control"]
                                            ])
                                            : _createCommentVNode("", true),
                                        ($setup.props.onDelete)
                                            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "btn btn-small btn-danger",
                                                "data-cy": "item-delete",
                                                title: _ctx.$t('JTADM_GRID_DELETE'),
                                                onClick: ($event) => (_ctx.$emit('delete', entry))
                                            }, [...(_cache[3] || (_cache[3] = [
                                                    _createElementVNode("i", { class: "dripicons-trash" }, null, -1)
                                                ]))], 8, _hoisted_14)), [
                                                [_directive_acl, $props.access, "grid_delete_control"]
                                            ])
                                            : _createCommentVNode("", true),
                                        _renderSlot(_ctx.$slots, "actions", { entry: entry })
                                    ])
                                ])), [
                                    [_directive_acl, $props.access, "grid_view_control"]
                                ])
                            ], 64))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ])
        ]),
        (($props.showPagination && $setup.pagesCount > 1) || $props.pageInfo?.hasPreviousPage || $setup.currentPage > 1)
            ? (_openBlock(), _createBlock($setup["Pagination"], {
                key: 1,
                "current-page": $setup.currentPage,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event) => (($setup.currentPage) = $event)),
                "total-pages": $setup.pagesCount,
                "page-info": $props.pageInfo,
                "is-loading": $props.isLoading
            }, null, 8, ["current-page", "total-pages", "page-info", "is-loading"]))
            : _createCommentVNode("", true)
    ]));
}
